module.exports = __webpack_public_path__ + "img/con_ot.8646a939.png";